import React, { useRef, useEffect } from 'react';
import { cn } from '@/utils/tailwind';
const MAX_HEIGHT = 120;
const MIN_HEIGHT = 40;

const AutoResizeTextarea = ({
  value,
  onChange,
  style,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const ta = textareaRef.current;
    if (ta) {
      ta.style.height = 'auto';
      ta.style.height = Math.min(ta.scrollHeight, MAX_HEIGHT) + 'px';
      // 만약 부모가 flex-1이면, textarea도 height 100%로 맞춰줌
      if (ta.parentElement) {
        ta.style.height = ta.parentElement.clientHeight + 'px';
      }
    }
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      className={cn(
        'h-full max-h-[120px] min-h-[40px] w-full  resize-none overflow-y-auto px-[4px] py-[8px] Body5M14 focus:outline-none', // ring-point-500 제거
        props.className,
      )}
      style={style}
      {...props}
    />
  );
};

export default AutoResizeTextarea;
